/**
 * API helpers for admin-provisioned custom contract offer password setup.
 */
import axios, { type AxiosResponse } from "axios";
import { backend_url } from "@/constants";
import { Endpoints } from "@/utils/api/endpoints";
import { AXIOS_CONFIG } from "@/utils/api";

interface BackendResponseShape<T> {
  message: string;
  content: T;
}

export interface CustomContractOfferInviteStatus {
  ownerEmail: string;
  ownerFirstName: string;
  businessId: string;
  businessName: string;
  mustSetPassword: boolean;
  pricingMode?: string;
  hasOffer?: boolean;
  offerId?: string;
}

export interface CustomContractOfferInviteCompleteResult extends CustomContractOfferInviteStatus {
  authenticated: boolean;
}

export const fetchCustomContractOfferInviteStatus = async (
  token: string
): Promise<CustomContractOfferInviteStatus | null> => {
  try {
    const response: AxiosResponse<
      BackendResponseShape<CustomContractOfferInviteStatus>
    > = await axios.get(
      `${backend_url}/${Endpoints.customContractOfferInviteStatus}`,
      { params: { token }, ...AXIOS_CONFIG }
    );
    if (response.status === 200) {
      return response.data.content;
    }
    return null;
  } catch (error) {
    console.error("Failed to verify custom contract offer invite token", error);
    return null;
  }
};

export const completeCustomContractOfferInvite = async (
  token: string,
  newPassword: string
): Promise<CustomContractOfferInviteCompleteResult> => {
  const response: AxiosResponse<
    BackendResponseShape<CustomContractOfferInviteCompleteResult>
  > = await axios.post(
    `${backend_url}/${Endpoints.customContractOfferInviteComplete}`,
    { token, newPassword },
    AXIOS_CONFIG
  );
  return response.data.content;
};
